class ProductRecommendationsSwiper extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.mySwiper-related-products');
    if (!swiperEl) return;
    new Swiper(swiperEl, {
      slidesPerView: 6, // số sản phẩm hiển thị cùng lúc
      spaceBetween: 20,
      loop: true, // lặp lại
      breakpoints: {
        320: { slidesPerView: 2 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 6 },
      },
    });
  }
}

customElements.define('product-recommendations-swiper', ProductRecommendationsSwiper);
